import { shape } from 'prop-types';
import AttachIcon from 'Assets/icons/attach-file-black.svg';
import dayjs from 'dayjs';
import usePreviewFile from 'Hooks/files/usePreviewFile';
import useAuth from 'Hooks/useAuth';

import styles from './styles.less';

const FileLine = ({ file }) => {
  const { handlePreview } = usePreviewFile();
  const { token } = useAuth();

  const handleOnClick = () => {
    handlePreview(file, token);
  };

  return (
    <div className={styles.lineWrapper} onClick={handleOnClick}>
      <img alt="attach" src={AttachIcon} />
      <div className={styles.fileInfo}>
        <div className={styles.fileName}>{file.name}</div>
        <div className={styles.createdDate}>{dayjs(file.createdAt).format('MMM DD, YYYY')}</div>
      </div>
    </div>
  );
};

FileLine.propTypes = {
  file: shape({}).isRequired,
};

export default FileLine;
